const React = require('react');
const PropTypes = require('prop-types');
// const { Link } = require('react-router-dom');
const classnames = require('classnames');
const { CSSTransition } = require('react-transition-group')
// const { OKButton } = require('components/commons/OKButton/OKButton');
const { FormattedText } = require('core/i18n').i18n;

const Card = require('components/cards/card/card.js');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { RadioButton } = require('commonsComponents/radioButton')
const CardsCreditBalanceBar = require('components/cards/cardsCreditBalanceBar/cardsCreditBalanceBar');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const Immutable = require('immutable');

const CardsControlButton = require('components/cards/cardsControlButton/cardsControlButton')

import { withRouter } from 'react-router-dom';

const { getLastNChars } = require('utilities/stringHelper');



class CardSelectorItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false
        }
    }

    componentDidMount() {
        const { preselected, card, onClick } = this.props
        preselected && card && onClick(card)

        setTimeout(() => this.setState({ show: true }), (this.props.index + 1) * 200)
    }

    componentDidUpdate(lastProps) {
        const lastPreselected = lastProps.preselected
        const { preselected, card, onClick } = this.props
        !lastPreselected && preselected && card && onClick(card)
    }

    handleLeaveWithoutModal = (route) => {
        const { disablePreLeaveModal, history } = this.props

        disablePreLeaveModal(() => history.push(route))

    }

    handleOnClick(c) {
        const { disabled, hasntEnoughFunds, onClick } = this.props;

        !disabled && !hasntEnoughFunds && onClick(c)

    }

    getCardLogo() {
        const { card, commercialAd} = this.props;
        const cardBrand = card.brand;
        const immCommercialCard = card.commercialCardInfo || commercialAd;
        const hasCommercialCardLogo = immCommercialCard && immCommercialCard.fieldImageMedium && immCommercialCard.fieldImageMedium.url;
        //TODO inmutable mustn't be used in a component, but i need mock the immCommercialAds Card prop
        const immCommercialAds = Immutable.fromJS({ byId: { [card.cardId]: immCommercialCard } })
        immCommercialAds
        const cardNumber = (
            <Card
                immCard={Immutable.fromJS(card)}
                immCommercialAds={immCommercialAds}
                showOnlyNumber={true}
            />
        );
        const cardLogoClass = classnames(
            'card-selector-radio-button__item__card-logo-div',
            {
                'card-selector-radio-button__item__card-logo--comercial': hasCommercialCardLogo
            }
        );
        let dataToRender;

        if (hasCommercialCardLogo) {
            const altValue = immCommercialCard.fieldAltText;
            const urlValue = immCommercialCard.fieldImageMedium && immCommercialCard.fieldImageMedium.url;

            dataToRender = (
                <div className={cardLogoClass}>
                    <img className="card-selector-radio-button__item__card-logo-image" alt={altValue} src={urlValue} />
                    {cardNumber}
                </div>
            );
        } else {
            dataToRender = (
                <div className={cardLogoClass}>
                    <div className={`icon-desktop-${cardBrand}-small icon-desktop-card`} />
                    {cardNumber}
                </div>
            )
        }

        return dataToRender;
    }

    renderButton = () => {
        const { card, active, disabled, hasntEnoughFunds } = this.props;


        if (disabled)
            return <CardsControlButton avoidCardControlButton={true} immCard={Immutable.fromJS(card)}/>

        if (hasntEnoughFunds)
            return (
                <OKButton
                    modifier="secondary"
                    size="small"
                    onClick={() => this.handleLeaveWithoutModal(`/myprofile/cards/${card.cardId}/modify-limit?redirect=${location.pathname}`)}
                >
                    <FormattedText value="cardSelectorRadioButton-modifyLimit" />
                </OKButton>
            )


        return <RadioButton isChecked={active}  />
    }

    render() {
        const { card, active, disabled, hasntEnoughFunds } = this.props;
        const { show } = this.state;
        if (!card) return null
        const cardNumber = (
            <span className="card-selector-radio-button__item__card-info--details">
                {getLastNChars(card.number, 4)}
            </span>
        );
        const cardLogo = this.getCardLogo();
        const cardTitle = (
            <div>
                {card.alias && card.alias.current}
            </div>
        );
        const cardLogoAndBrand = (
            <div className="card-selector-radio-button__item__card-logo">
                {cardLogo}
            </div>
        );
        let balanceContent, iconBeneficiaries, cardsBoxHeaderView;
        const divClassName = classnames('card-selector-radio-button__item',
            {
                'card-selector-radio-button__item--hidden': !show,
                'card-selector-radio-button__item--active': active,
                'card-selector-radio-button__item--disabled': disabled || hasntEnoughFunds
            })


        balanceContent = (
            <div className="card-selector-radio-button__item__card-info-bar">
                <CardsCreditBalanceBar immCard={Immutable.fromJS(card)} showTooltip={false} />
            </div>
        )
        const infoSectionClass = classnames(
            'card-selector-radio-button__item__card-info-inner'
        );

        const buttonsSection = (
            <div className="card-selector-radio-button__item__card-info-buttons pull-right">
                {this.renderButton()}
            </div>
        );

        cardsBoxHeaderView = (
            <div className={divClassName} onClick={() => this.handleOnClick(card)}>
                <div className="row">
                    <div className="col-xs-2">
                        {cardLogoAndBrand}
                    </div>
                    <div className="col-xs-10">
                        <div className="card-selector-radio-button__item__card-info">
                            <div>
                                <div>
                                    {buttonsSection}
                                    <div className={infoSectionClass}>
                                        {cardTitle}
                                        {cardNumber}
                                        {iconBeneficiaries}
                                    </div>
                                </div>
                                {balanceContent}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (disabled)
            cardsBoxHeaderView =  (
                <OKTooltip
                    content="cardSelectorRadioButton-activeCard"
                    offset={[0, -10]}
                    target={cardsBoxHeaderView}
                />
            )


        return (
            <CSSTransition in={show} timeout={1000} classNames="right-to-left">
                {cardsBoxHeaderView}
            </CSSTransition>
        )
    }
}

CardSelectorItem.propTypes = {
    history: PropTypes.object.isRequired,
    card: PropTypes.object.isRequired,
    commercialAd:  PropTypes.object,
    preselected: PropTypes.bool,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    accountId: PropTypes.string,
    index: PropTypes.number,
    hasntEnoughFunds: PropTypes.bool,
    disablePreLeaveModal: PropTypes.func
}

module.exports.constructor = CardSelectorItem;
module.exports.CardSelectorItem = withRouter(CardSelectorItem)

